/**
 * @generated SignedSource<<50b25208f7d0bdd9d1c924e9659686a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentMethodType = "ACH" | "AFFIRM_CREDIT_CARD" | "APPLE_PAY" | "APPLIED_SALE" | "CASH" | "CHECK" | "CREDIT_CARD" | "CREDIT_TO_USER_ACCOUNT" | "DIRECT_PAYMENT" | "DISCOUNT" | "HYPERWALLET" | "KLARNA" | "ON_PLATFORM_WIRE_TRANSFER" | "OTHER" | "PAYPAL_ACCOUNT" | "PAY_LATER" | "UNKNOWN" | "WIRE_TRANSFER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type usePayPalPaymentMethod_buyer$data = {
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: "PayPalAccount";
        readonly email: string | null;
        readonly paymentMethodType: PaymentMethodType | null;
        readonly token: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "usePayPalPaymentMethod_buyer";
};
export type usePayPalPaymentMethod_buyer$key = {
  readonly " $data"?: usePayPalPaymentMethod_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePayPalPaymentMethod_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePayPalPaymentMethod_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "paymentMethodType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "type": "PayPalAccount",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6a8e8a758b05e75ed3fb99fc974d7e90";

export default node;
